var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMilk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.80049 1H8.20047M2.60049 1V3.2312C2.60047 3.86303 2.41341 4.48071 2.06289 5.00639L1.53809 5.79359C1.18741 6.3195 1.00035 6.93749 1.00049 7.56959V15.4C1.00049 15.8243 1.16906 16.2313 1.46912 16.5313C1.76917 16.8314 2.17614 17 2.60049 17H7.40048C7.82482 17 8.23179 16.8314 8.53184 16.5313C8.8319 16.2313 9.00047 15.8243 9.00047 15.4V7.56879C9.00046 6.93696 8.8134 6.31927 8.46287 5.79359L7.93807 5.00639C7.5874 4.48048 7.40033 3.8625 7.40048 3.2304V1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00049 11.4C1.63388 11.1346 2.31375 10.998 3.00048 10.998C3.68722 10.998 4.36708 11.1346 5.00048 11.4C5.63388 11.6653 6.31374 11.802 7.00048 11.802C7.68721 11.802 8.36708 11.6653 9.00047 11.4",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilk);
export default __webpack_public_path__ + "static/media/milk.46570d2e8b76870d0bba740a0f24491b.svg";
export { ForwardRef as ReactComponent };